module.exports = __webpack_public_path__ + "static/img/bg_home_vip_tui.75e48287.png";